import React from 'react'
import { Grid, IconButton } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SettingsIcon from '@mui/icons-material/Settings'
import BuildIcon from '@mui/icons-material/Build'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt'
import ForumIcon from '@mui/icons-material/Forum'
import { FaUser, FaTrophy } from 'react-icons/fa'
import NunitoText from './NunitoText'
// Section header for form pages. Phase 2: a light card header (it used to be a
// filled brand bar, which hid the brand-coloured buttons placed inside it).
export default function TitleBar({ title, state, setState, children, main, info, fixed }) {
    let icon;
    const iconStyle = { color: 'var(--color-text-tertiary)', marginLeft: 10, fontSize: 18 }
    switch (title) {
        case 'Setting':
        case 'Answer Setting':
            icon = <SettingsIcon style={iconStyle} />; break;
        case 'Recommendations': icon = <ThumbUpAltIcon style={iconStyle} />; break;
        case 'Participating Countries':
        case 'Country Partners': icon = <FaUser style={iconStyle} />; break;
        case 'Rounds': icon = <BuildIcon style={iconStyle} />; break;
        case 'Awards': icon = <FaTrophy style={iconStyle} />; break;
        case 'Sections': icon = <ForumIcon style={iconStyle} />; break
        default:
    }
    const containerStyle = {
        backgroundColor: 'var(--color-surface)', borderRadius: '10px 10px 0 0', minHeight: 56,
        border: '1px solid var(--color-border)', marginTop: 20, marginInline: !main && 30
    }
    const centerFlexStyle = { display: 'flex', alignItems: 'center' }
    return (
        <Grid container alignItems='center' justifyContent='space-between' style={containerStyle}>
            <div style={centerFlexStyle}>
                {title && <NunitoText value={title} fontSize={15} fontWeight={640} color='var(--color-text)' marginLeft={20} />}
                {icon}
                {info}
            </div>
            <div style={centerFlexStyle}>
                {children}
                {!fixed && <IconButton style={{ color: 'var(--color-text-secondary)', marginRight: 6 }} onClick={() => setState(!state)} edge="start"
                    aria-label={state ? 'Collapse section' : 'Expand section'}>
                    {state ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>}
            </div>
        </Grid>
    )
}
